<template>
  <div class="ppt-outline">
    <div class="outline-pane">
      <div class="loading-container" v-if="outlineLoading">
        <PPTLoding />
      </div>

      <outline-tree
        ref="outlineTree"
        v-if="!outlineLoading"
        :isExpanded="isExpanded"
        :outline-data="addUUIDs(outline)"
      />
      <div class="outline-action">
	        <div class="fold item" data-track-text="折叠PPT大纲细节" aria-label="折叠PPT大纲细节" @click="switchFold">
          <span class="icon"></span>
          <span class="text">折叠页内细节</span>
        </div>
	        <div class="change-outline item" data-track-text="换个PPT大纲" aria-label="换个PPT大纲" @click="createOutline">
          <span class="icon"></span>
          <span class="text">换个大纲</span>
        </div>
	        <div class="change-template item" data-track-text="挑选PPT模板" aria-label="挑选PPT模板" @click="changeTemplate">
          <span class="icon"></span>
          <span class="text">挑选模版</span>
        </div>
      </div>
    </div>
    <div class="ppt-preview">
      <div class="preview-title">PPT预览</div>
	      <div class="change-style" data-track-text="更换PPT风格" aria-label="更换PPT风格" @click="changeTemplate">
        <span class="icon"></span>
        <span class="text">更换风格</span>
      </div>
      <div class="ppt-big">
        <img :src="currentBigImage" alt="" />
      </div>
      <div class="list-container">
        <div class="container" ref="previewViewport">
          <div class="ppt-list" ref="previewList" :style="pptListStyle">
            <div
              class="ppt-item"
              :class="[item === currentBigImage ? 'select' : '']"
	              v-for="(item, index) in detailList"
	              :key="item"
	              :data-track-text="`选择PPT预览第${index + 1}页`"
	              :aria-label="`选择PPT预览第${index + 1}页`"
	              @click="selectCurrentBigImage(item)"
            >
              <img :src="item" alt="" />
              <span class="tips">{{ index + 1 }}/{{ detailList.length }}</span>
            </div>
          </div>
        </div>
        <span class="left" data-track-text="上一个风格" aria-label="上一个风格" @click="setStyle(-1)">
          <i class="el-icon-zuojiantou"></i>
        </span>
        <span class="right" data-track-text="下一个风格" aria-label="下一个风格" @click="setStyle(1)">
          <i class="el-icon-zuojiantou" style="transform: rotate(180deg)"></i>
        </span>
      </div>
	      <div class="create-ppt" data-track-text="生成PPT" aria-label="生成PPT" @click="createPPT">
        <span class="icon"></span>
        <span class="text">生成PPT</span>
      </div>
    </div>
    <PPTTemplate ref="pptTemplate" btnText="确定" @commit="selectTemplate" />
  </div>
</template>

<script>
import OutlineTree from "./OutlineTree.vue";
import PPTTemplate from "./PPTTemplate";
import PPTLoding from "./PPTLoding";
export default {
  components: {
    OutlineTree,
    PPTTemplate,
    PPTLoding,
  },
  props: {
    pptConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      sid: "",
      outline: {},
      pptTemplateList: [],
      isExpanded: true,
      pptConfigCopy: {},
      detailList: [],
      currentBigImage: "",
      outlineLoading: false,
      pptListStyle: {
        left: "-60px",
      },
    };
  },
  computed: {
    detailImages() {
      const detailImage = this.pptConfigCopy.selectTemplate?.detailImage;
      if (detailImage) {
        const detailList = [
          detailImage.titleCoverImage,
          detailImage.catalogueCoverImage,
          detailImage.chapterCoverImage,
          detailImage.contentCoverImage,
          detailImage.endCoverImage,
        ];
        return detailList;
      }
      return [];
    },
  },
  watch: {
    detailImages: {
      handler(newVal, oldVal) {
        this.detailList = JSON.parse(JSON.stringify(newVal));
        this.currentBigImage = this.currentBigImage || this.detailList[0];
        this.resetPreviewStrip();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    console.log(123, this.pptConfig);
    this.pptConfigCopy = this.pptConfig;
    this.createOutline();
    window.addEventListener("resize", this.clampPreviewStrip);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.clampPreviewStrip);
  },
  methods: {
    selectCurrentBigImage(item) {
      this.currentBigImage = item;
    },
    setStyle(action) {
      const currentLeft = Number.parseInt(this.pptListStyle.left, 10) || 0;
      const nextLeft = currentLeft + (action === 1 ? -169 : 169);
      const { minLeft, maxLeft } = this.getPreviewStripBounds();
      const clampedLeft = Math.min(maxLeft, Math.max(minLeft, nextLeft));
      this.pptListStyle.left = `${clampedLeft}px`;
    },
    getPreviewStripBounds() {
      const viewport = this.$refs.previewViewport;
      const list = this.$refs.previewList;
      if (!viewport || !list) {
        return { minLeft: 0, maxLeft: 0 };
      }

      const lastItem = list.lastElementChild;
      const lastItemStyle = lastItem ? window.getComputedStyle(lastItem) : null;
      const contentWidth = lastItem
        ? lastItem.offsetLeft +
          lastItem.offsetWidth +
          (Number.parseFloat(lastItemStyle.marginRight) || 0)
        : 0;

      return {
        minLeft: Math.min(0, viewport.clientWidth - contentWidth),
        maxLeft: 0,
      };
    },
    clampPreviewStrip() {
      this.$nextTick(() => {
        const currentLeft = Number.parseInt(this.pptListStyle.left, 10) || 0;
        const { minLeft, maxLeft } = this.getPreviewStripBounds();
        const clampedLeft = Math.min(maxLeft, Math.max(minLeft, currentLeft));
        this.pptListStyle.left = `${clampedLeft}px`;
      });
    },
    resetPreviewStrip() {
      this.pptListStyle.left = "-60px";
      this.clampPreviewStrip();
    },
    switchFold() {
      this.isExpanded = !this.isExpanded;
    },
    generateUUID() {
      // 检查浏览器是否支持 crypto.randomUUID()
      if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
      }
      // 如果不支持，回退到其他方法
      return this.generateUUIDFallback();
    },
    generateUUIDFallback() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    addUUIDs(data) {
      // 如果是数组，遍历每个元素
      if (Array.isArray(data)) {
        return data.map((item) => this.addUUIDs(item));
      }
      if (typeof data === "object" && data !== null) {
        return {
          ...data,
          uuid: this.generateUUID(),
          chapterContents:
            data.chapters || data.chapterContents
              ? this.addUUIDs(data.chapters || data.chapterContents)
              : undefined,
        };
      }

      return data;
    },
    changeTemplate() {
      this.$refs.pptTemplate.show(this.pptConfigCopy);
    },
    selectTemplate(pptConfig) {
      this.currentBigImage = "";
      this.pptConfigCopy = pptConfig;
    },
    removeUUID(data) {
      // 如果是数组，处理每个元素
      if (Array.isArray(data)) {
        return data.map((item) => this.removeUUID(item));
      }
      // 如果是对象，处理每个属性
      else if (typeof data === "object" && data !== null) {
        const newObj = {};

        for (const key in data) {
          // 跳过uuid字段
          if (key === "uuid") continue;

          // 递归处理其他字段
          newObj[key] = this.removeUUID(data[key]);
        }

        return newObj;
      }
      // 基本类型直接返回
      else {
        return data;
      }
    },
    createPPT() {
      if (this.outlineLoading || !this.$refs.outlineTree) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在创建ppt",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const outline = {
        ...this.$refs.outlineTree.outline,
        // chapters: this.$refs.outlineTree.outline.chapterContents,
      };
      const outlineClone = this.removeUUID({
        title: this.$refs.outlineTree.outline.title,
        subTitle: this.$refs.outlineTree.outline.subTitle,
        chapters: this.$refs.outlineTree.outline.chapterContents,
      });
      let apiUrl = "";
      let params = {};
      if (this.pptConfigCopy.filters.file) {
        const formData = new FormData();
        formData.append("file", this.pptConfigCopy.filters.file);
        formData.append("outline", outline);
        formData.append("outlineSid", this.sid);
        formData.append("language", this.pptConfigCopy.filters.language);
        formData.append("chatId", this.pptConfigCopy.filters.chatId);
        formData.append(
          "modelVersion",
          this.pptConfigCopy.filters.modelVersion
        );
        formData.append("model", this.pptConfigCopy.filters.model);
        formData.append(
          "templateId",
          this.pptConfigCopy.selectTemplate.templateIndexId
        );
        params = formData;
        apiUrl = "/chatApi/v1/chatPpt/create";
      } else {
        params = {
          ...this.pptConfigCopy.filters,
          outline,
          outlineSid: this.sid,
          templateId: this.pptConfigCopy.selectTemplate.templateIndexId,
        };
        apiUrl = "/chatApi/v1/chatPpt/createByOutline";
      }
      this.$http
        .post(apiUrl, params)
        .then((res) => {
          if (res.data.success) {
            this.$message.success("生成成功");
            this.$emit("goback");
          } else {
            this.$message.error("生成失败");
          }
          loading.close();
        })
        .catch(() => {
          this.$message.error("生成失败");
        });
    },
    createOutline() {
      this.outlineLoading = true;
      let params = {};
      let apiUrl = "";

      if (this.pptConfigCopy.filters.file) {
        const formData = new FormData();
        formData.append("file", this.pptConfigCopy.filters.file);
        formData.append("language", this.pptConfigCopy.filters.language);
        formData.append("chatId", this.pptConfigCopy.filters.chatId);
        formData.append(
          "modelVersion",
          this.pptConfigCopy.filters.modelVersion
        );
        formData.append("model", this.pptConfigCopy.filters.model);
        params = formData;
        apiUrl = "/chatApi/v1/chatPpt/createOutlineByDoc";
      } else {
        params = {
          ...this.pptConfigCopy.filters,
        };
        apiUrl = "/chatApi/v1/chatPpt/createOutline";
      }
      this.$http
        .post(apiUrl, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.sid = res.data.data.sid;
            this.outline = res.data.data.outline;
          } else if (res.data.code === 600 && !res.data.success) {
            this.$emit("showPop");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .finally(() => {
          this.outlineLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.ppt-outline {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(420px, 2fr);
  grid-template-rows: minmax(0, 1fr);
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;

  > .outline-pane {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 0;
    min-height: 0;
    padding: 24px 20px 18px;
    box-sizing: border-box;
    overflow: hidden;
    background: var(--bg-card);

    > .loading-container {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 0;
    }

    > .outline-action {
      display: flex;
      flex: 0 0 auto;
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
      margin-top: 16px;

      .item {
        flex: 1 1 150px;
        max-width: 220px;
        padding: 12px;
        box-sizing: border-box;
        border: 1px solid var(--primary);
        border-radius: var(--radius-sm);
        font-size: 14px;
        color: var(--primary-dark);
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        transition: background-color .15s, border-color .15s;

        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 6px;
          vertical-align: middle;
        }
      }

      .fold .icon {
        background: url(../../assets/chat/hide.png) left no-repeat;
        background-size: contain;
        filter: invert(42%) sepia(93%) saturate(2476%) hue-rotate(121deg) brightness(95%) contrast(101%);
      }

      .change-outline .icon {
        background: url(../../assets/chat/change2.png) left no-repeat;
        background-size: contain;
        filter: invert(42%) sepia(93%) saturate(2476%) hue-rotate(121deg) brightness(95%) contrast(101%);
      }

      .change-template .icon {
        background: url(../../assets/chat/template.png) left no-repeat;
        background-size: contain;
        filter: invert(42%) sepia(93%) saturate(2476%) hue-rotate(121deg) brightness(95%) contrast(101%);
      }
    }
  }

  > .ppt-preview {
    position: relative;
    display: flex;
    flex-direction: column;
    width: auto;
    height: 100%;
    min-width: 0;
    min-height: 0;
    padding: 24px;
    box-sizing: border-box;
    overflow: hidden;
    background: var(--bg-subtle);
    border: 1px solid var(--border);

    .preview-title {
      flex: 0 0 auto;
      margin: 0;
      font-size: 24px;
      color: var(--foreground-secondary);
      line-height: 32px;
      text-align: center;
    }

    .change-style {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 135px;
      height: 40px;
      background: var(--primary);
      border-radius: var(--radius-md);
      text-align: center;
      cursor: pointer;
      transition: background-color .15s, box-shadow .15s;

      &:hover {
        background: var(--primary-dark);
        box-shadow: var(--shadow-primary);
      }

      .icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 4px;
        vertical-align: middle;
        background: url(../../assets/chat/change.png) center no-repeat;
        background-size: contain;
        filter: brightness(0) saturate(100%) invert(100%);
      }

      .text {
        font-size: 14px;
        color: #ffffff;
        line-height: 40px;
      }
    }

    .ppt-big {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 0;
      margin: 20px 0;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border: 1px dashed var(--border);
        border-radius: var(--radius-md);
      }
    }

    .list-container {
      position: relative;
      flex: 0 0 94px;
      width: 100%;
      height: 94px;
      margin-top: 0;
      overflow: hidden;
      text-align: center;

      .container {
        position: relative;
        width: calc(100% - 80px);
        max-width: 900px;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;

        .ppt-list {
          position: absolute;
          top: 0;
          left: -60px;
          width: 944px;

          .ppt-item {
            position: relative;
            display: inline-block;
            width: 148px;
            height: 92px;
            margin: 0 10px;
            box-sizing: border-box;
            border-radius: var(--radius-md);
            cursor: pointer;

            &.select img {
              border: 2px solid var(--primary);
            }

            img {
              width: 150px;
              height: 92px;
              box-sizing: border-box;
              border-radius: var(--radius-md);
            }

            .tips {
              position: absolute;
              right: 8px;
              bottom: 10px;
              padding: 4px 6px;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 2px;
              font-size: 12px;
              color: #ffffff;
            }
          }
        }
      }

      .left,
      .right {
        position: absolute;
        top: 35px;
        cursor: pointer;

        &:hover {
          color: var(--primary-dark);
        }
      }

      .left {
        left: 16px;
      }

      .right {
        right: 16px;
      }
    }

    .create-ppt {
      flex: 0 0 36px;
      width: 220px;
      height: 36px;
      margin: 20px auto 0;
      background: var(--primary);
      border-radius: var(--radius-sm);
      text-align: center;
      cursor: pointer;
      transition: background-color .15s, box-shadow .15s;

      &:hover {
        background: var(--primary-dark);
        box-shadow: var(--shadow-primary);
      }

      .icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        margin-right: 4px;
        vertical-align: middle;
        background: url(../../assets/chat/export.png) center no-repeat;
        background-size: contain;
        filter: brightness(0) saturate(100%) invert(100%);
      }

      .text {
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
      }
    }
  }
}

@media (max-width: 1399px) {
  .ppt-outline {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

/* PPT 大纲和预览在手机端改为上下排列。 */
@media (max-width: 768px) {
  .ppt-outline {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(480px, auto) minmax(480px, auto);
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;

    > .outline-pane {
      width: 100%;
      height: auto;
      min-width: 0;
      min-height: 480px;
      padding: 14px 10px;

      /deep/ .outline-header {
        margin-bottom: 12px;
        font-size: 20px;
      }

      /deep/ .chapters-tree {
        width: 100%;
        margin: 0;
        padding: 12px;
      }

      > .outline-action {
        gap: 8px;
        margin-top: 12px;

        .item {
          flex: 1 1 calc(50% - 4px);
          min-width: 0;
          max-width: none;
          padding: 10px 6px;
          font-size: 13px;
        }
      }
    }

    > .ppt-preview {
      width: 100%;
      height: auto;
      min-width: 0;
      min-height: 480px;
      padding: 14px 12px;

      .preview-title {
        font-size: 19px;
        line-height: 28px;
      }

      .change-style {
        position: static;
        align-self: flex-end;
        width: 112px;
        height: 32px;
        margin-top: 6px;

        .text {
          font-size: 13px;
          line-height: 32px;
        }
      }

      .ppt-big {
        flex: 0 0 auto;
        width: 100%;
        height: auto;
        margin: 12px 0;
        aspect-ratio: 16 / 9;
      }

      .list-container {
        flex-basis: 84px;
        height: 84px;

        .container {
          width: calc(100% - 56px);
        }

        .left {
          left: 4px;
        }

        .right {
          right: 4px;
        }
      }

      .create-ppt {
        width: 100%;
        max-width: 220px;
        margin-top: 14px;
      }
    }
  }
}
</style>
